import {Box} from '@mui/material';
import {string} from 'prop-types';

import {controlPropType, fieldPropType} from '../../../../proptypes-shapes';
import {buildFieldName} from '../buildFieldName';
import FieldLabel from '../field-components/EmmaiFieldLabel/EmmaiFieldLabel';
import MultipleAutocomplete from '../field-components/MultipleAutocomplete/MultipleAutocomplete';

const MultipleAutocompleteRenderer = ({control, field, prefix, helperText, error}) => (
  <Box overflow="hidden">
    {field.label && <FieldLabel required={field.required}>{field.label}</FieldLabel>}

    <MultipleAutocomplete helperText={helperText} error={error} name={buildFieldName(field, prefix)} control={control} placeholder={field.placeholder} disabled={field.disabled} />
  </Box>
);

MultipleAutocompleteRenderer.propTypes = {
  control: controlPropType.isRequired,
  field: fieldPropType.isRequired,
  prefix: string,
  error: string,
  helperText: string
};

export default MultipleAutocompleteRenderer;
